

import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from "vuex-class";

import "@/store/modules/forms/form14";
const form14State = namespace("Form14");

import { form14DataInfoType, form14PartiesInfoType } from '@/types/Information/Form14';
import {getPartyTitles} from '../PartyTitlesForm14'


@Component
export default class Form14Layout extends Vue {

    @Prop({required:true})
    result!: form14DataInfoType; 

    @form14State.Action
    public UpdateForm14Info!: (newForm14Info: form14DataInfoType) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    
    applicantNamesFull='';
    respondentNamesFull='';    
    signingParties='';

    signingPartyList =[]    

    mounted(){
        this.extractInfo();       
        this.dataReady = true;
    }
   
    public extractInfo(){        
       
        this.applicantNames = [];
        this.respondentNames = [];        

        for (const resInx in this.result.respondents){
            const fullTitle = getPartyTitles(this.result.respondents[resInx],' ')
            this.respondentNames.push(fullTitle);
        }
        this.respondentNamesFull = this.combineNames(this.result.respondents, '', this.respondentNames)
      

        for (const appInx in this.result.appellants){
            const fullTitle = getPartyTitles(this.result.appellants[appInx],' ')
            this.applicantNames.push(fullTitle);            
        }
        this.applicantNamesFull = this.combineNames(this.result.appellants, '', this.applicantNames)

        this.extractSigningParties();        
    }  

    public extractSigningParties(){
        
        const appearingAppellants = this.result.signingParties.filter(party=> !party.responding)
        const appearingRespondents = this.result.signingParties.filter(party=> party.responding)
                               
        const appellantnames = this.combineNames(appearingAppellants, 'name', null, ', appellant')                   
        const respondentnames = this.combineNames(appearingRespondents, 'name', null, ', respondent') 

        this.extractSigningPartyList(appearingAppellants, appearingRespondents)

        this.signingParties += appellantnames
        this.signingParties += (appellantnames && respondentnames)?' and ':''
        this.signingParties += respondentnames 
        this.signingParties += (!appellantnames)?  ' and no one appearing on behalf of the appellant(s)':''
        this.signingParties += (!respondentnames)? ' and no one appearing on behalf of the respondent(s)':''
    }

    public extractSigningPartyList(appearingAppellants, appearingRespondents){
        const allParties: form14PartiesInfoType[] = [...appearingAppellants, ...appearingRespondents]        
        this.signingPartyList =[]
        for(const party of allParties){
            if(!party.isCounsel){
                const sameParty = allParties.filter(par => {
                    return(
                        (par.organization && par.isOrganization && par.organization==party.organization) ||
                        (par.firstName && par.lastName && par.firstName == party.firstName && par.lastName == party.lastName)
                    )
                })
                if(sameParty.length==1) this.signingPartyList.push(party)
            }else{
                this.signingPartyList.push(party)
            }
        }
    }
    
    public combineNames(names, nameField?, addingNameArray?, role?){
        let namesString = ''
        
        const numberOfNames = names.length       
        for(const index in names){
            
            let addingName = ''
            const partyRole = role? (role+  
                (!names[index].isCounsel && !names[index].isOrganization?', appearing in person':'')) 
            : ''            

            if(addingNameArray?.length>0){
                addingName = addingNameArray[index] + partyRole
            }
            else if(nameField)
                addingName = names[index][nameField] + partyRole
            else
                addingName = names[index] + partyRole

            if(Number(index)>0 && Number(index)+1 == numberOfNames)
                namesString += ' and '+addingName
            else if(Number(index)==0)
                namesString += addingName
            else
                namesString += ', '+addingName
        }
        return namesString
    }
}

